import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SaulDr from '@/assets/imgs/saul-dr.png';

export default /*@__PURE__*/_defineComponent({
  __name: 'PageInDevelopment',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "hide fill-height d-flex flex-column align-center justify-center text-center" }, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "text-h4 my-4" }, "DR University", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-subtitle-1 mb-6" }, "This page is currently under development. Please check back later!", -1)),
      _createVNode(_component_v_img, {
        src: _unref(SaulDr),
        alt: "Saul Goodman DR University",
        width: "500",
        "aspect-ratio": "1",
        contain: ""
      }, null, 8, ["src"])
    ]),
    _: 1
  }))
}
}

})